import React, { useRef, useEffect, useState } from "react"; // Додано useState
import { Card, PageContent, Block, BlockTitle, Sheet, f7, Button } from "framework7-react";
import { getStoragedOperatorInfo } from "../../auth/authHelper";
import { useTranslation } from "react-i18next";
import "./Withdraw.css";

export const Withdraw = () => {
    const notificationFull = useRef<any | null>(null);
    let operatorData = getStoragedOperatorInfo();
    const { t } = useTranslation();

    const showNotificationFull = async () => {

        if (!notificationFull.current) {
            notificationFull.current = f7.notification.create({

                title: `${t("dashboard.withdraw")}`,
                subtitle: `${t("notifications.withdrawMoneyOnWay")}`,
                text: `${t("notifications.checkYourWallet")}`,
                closeTimeout: 3000,
            });
        }
        notificationFull.current.open();

        (document.activeElement as HTMLElement)?.blur();
        f7.sheet.close(".demo-sheet-swipe-to-close");
    };

    return (
        <>
            <Card className="withdraw-action">
                {/* Кнопка відкриття Sheet */}
                <div className='withdraw-action-btn' onClick={() => f7.sheet.open(".demo-sheet-swipe-to-close")}>
                    <p className="earnmoney-title">{t("dashboard.withdraw")}</p>
                    <p className="earnmoney-subtitle">{t("dashboard.tapToWithdrawMoney")}</p>
                </div>
            </Card>
            <Sheet
                className="demo-sheet-swipe-to-close"
                style={{ height: "auto" }}
                swipeToClose
                push
                backdrop
            >
                <div className="swipe-handler"></div>
                <PageContent>
                    <BlockTitle large className='text-align-center'>{t("dashboard.withdrawBalanceTitle")}</BlockTitle>
                    <Block>
                        {/* Інформація про баланс */}
                        <p className='text-align-center' style={{ fontSize: '24px', fontWeight: 'bold' }}>
                            1.250,00 {operatorData?.currency ?? ""}
                        </p>

                        <Button large raised fill onClick={showNotificationFull}>
                            {t("dashboard.withdrawNow")}
                        </Button>
                        <p className='text-align-center' style={{ fontSize: '12px' }}>
                            {t("dashboard.withdrawSendMoneyTo")}
                            +254 000002331
                        </p>
                    </Block>
                </PageContent>
            </Sheet>
        </>
    );
};

// Не забудьте додати переклади для нових або змінених ключів:
/*
{
  "notifications": {
    // ... існуючі переклади ...
    "testPushBodyInstant": "Це тестове сповіщення з'явилося одразу!",
    "permissionBlockedMessage": "Ви заблокували сповіщення. Щоб їх отримувати, змініть налаштування браузера для цього сайту."
    // ... інші ваші переклади ...
  }
}
*/